import React from 'react';
// BottomSheetModal removed - using regular div

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  confirmText,
  confirmColor = 'bg-red-500',
  showCancel = true,
  isLoading = false,
  loadingText = null,
}) => {
  if (!isOpen) return null;

  // Check if device is mobile
  const isMobile = window.innerWidth < 1024;

  // Default loading text based on confirm text or use provided loadingText
  const displayLoadingText = loadingText || (confirmText ? confirmText.replace('Yes, ', '') : 'Loading...');
  const displayConfirmText = isLoading ? displayLoadingText : confirmText;

  const content = (
    <div className="text-center">
      <div className="text-gray-600 mb-6">{children}</div>
      <div className="space-y-3">
        <button
          onClick={onConfirm}
          disabled={isLoading}
          className={`w-full ${confirmColor} text-white font-bold py-4 rounded-xl transition active:scale-95 min-h-[48px] disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center`}
        >
          {isLoading && (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          )}
          {displayConfirmText}
        </button>
        {showCancel && (
          <button
            onClick={onClose}
            disabled={isLoading}
            className="w-full text-gray-600 font-bold py-3 min-h-[44px] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
        )}
      </div>
    </div>
  );

  // Use bottom sheet on mobile, center modal on desktop
  if (isMobile) {
    return (
      <div className={`fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto ${isOpen ? 'block' : 'hidden'}`}>
        <div className="bg-white rounded-2xl p-6 text-center w-full max-w-md mx-auto my-auto max-h-[90vh] overflow-y-auto">
          <h2 className="text-2xl font-bold mb-4">{title}</h2>
          {content}
        </div>
      </div>
    );
  }

  // Desktop version (center modal)
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl p-6 text-center w-full max-w-sm my-auto max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-extrabold mb-2">{title}</h2>
        {content}
      </div>
    </div>
  );
};

export default ConfirmationModal;
